import { Button } from "@dash/form";
import { useDeviceType } from "@dash/mq";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { useNavigate } from "react-router-dom-v5-compat";

type Props = {
  legacyUserId: number;
  className?: string;
};

export const GoToVisitsButton = ({ legacyUserId, className }: Props) => {
  const navigate = useNavigate();

  const { isMobile } = useDeviceType();

  return (
    <Button
      icon={<MdOutlineCalendarMonth />}
      variant="outline"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/crm/pos/handlowcy/${legacyUserId}/wizyty/tydzien`);
      }}
      className={className}
    >
      {!isMobile && "Wizyty"}
    </Button>
  );
};
